import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../../ip_api.config')

class Flim_EditMasterOption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            type: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit,
                type: this.props.location.state.type
            }, () => {
                this.get_masterStandard()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    get_masterStandard = () => {
        console.log('id', this.state.id)
        console.log('type', this.state.type)
        this.setState({ isLoading: true })
        let arr = []
        let temp

        let url
        if (this.state.type === 'ItemG1') {
            url = proxy.server + '/flim/getMaster_ItemG1'
        } else if (this.state.type === 'ItemG2') {
            url = proxy.server + '/flim/getMaster_ItemG2'
        } else if (this.state.type === 'ItemG3') {
            url = proxy.server + '/flim/getMaster_ItemG3'
        } else if (this.state.type === 'IBrand1') {
            url = proxy.server + '/flim/getMaster_Ibrand1'
        } else if (this.state.type === 'IBrand2') {
            url = proxy.server + '/flim/getMaster_Ibrand2'
        } else if (this.state.type === 'Rawmat') {
            url = proxy.server + '/flim/getMaster_Rawmat'
        } else if (this.state.type === 'SortProduct') {
            url = proxy.server + '/flim/getMaster_SortProduct'
        } else if (this.state.type === 'Size') {
            url = proxy.server + '/flim/getMaster_Size'
        } else if (this.state.type === 'Detail') {
            url = proxy.server + '/flim/getMaster_Detail'
        }

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        type: val.type,
                        code: val.code,
                        description: val.description,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => {
                    console.log("arr_save", this.state.arr_save)
                    this.preview_masterStandard()
                })
            })
    }

    preview_masterStandard = () => {
        let arr = []

        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td>{i + 1}</td>
                    {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                        ? <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.type} />
                            </bs4.Col>
                        </td>
                        : ''
                    }
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.code} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.description} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (index === 'a') {
            if (name === 'type') {
                this.state.arr_save.map(function (val, i) {
                    val.type = value
                })
            } else if (name === 'code') {
                this.state.arr_save.map(function (val, i) {
                    val.code = value
                })
            } else if (name === 'description') {
                this.state.arr_save.map(function (val, i) {
                    val.description = value
                })
            }
        } else if (name === 'type') {
            this.state.arr_save[index].type = value
        } else if (name === 'code') {
            this.state.arr_save[index].code = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.preview_masterStandard()
        })
    }

    update_masterStandard = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url
            if (this.state.type === 'ItemG1') {
                url = proxy.server + '/flim/update_ItemG1'
            } else if (this.state.type === 'ItemG2') {
                url = proxy.server + '/flim/update_ItemG2'
            } else if (this.state.type === 'ItemG3') {
                url = proxy.server + '/flim/update_ItemG3'
            } else if (this.state.type === 'IBrand1') {
                url = proxy.server + '/flim/update_Ibrand1'
            } else if (this.state.type === 'IBrand2') {
                url = proxy.server + '/flim/update_Ibrand2'
            } else if (this.state.type === 'Rawmat') {
                url = proxy.server + '/flim/update_Rawmat'
            } else if (this.state.type === 'SortProduct') {
                url = proxy.server + '/flim/update_SortProduct'
            } else if (this.state.type === 'Size') {
                url = proxy.server + '/flim/update_Size'
            } else if (this.state.type === 'Detail') {
                url = proxy.server + '/flim/update_Detail'
            }

            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            localStorage.setItem("type", this.state.type)

                            this.props.history.push({
                                pathname: '/Flim/MasterOption'
                            })
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >Edit Master Option</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_masterStandard()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                {
                    this.state.type === 'ItemG1'
                        ? <div>
                            <bs4.Table bordered hover>
                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th>ลำดับ</th>
                                        <th>type</th>
                                        <th>code</th>
                                        <th>description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                            ? <td>
                                                <bs4.Col sm='12'>
                                                    <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                </bs4.Col>
                                            </td>
                                            : ''
                                        }
                                        <td>
                                            <bs4.Col sm='12'>
                                                <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                            </bs4.Col>
                                        </td>
                                        <td>
                                            <bs4.Col sm='12'>
                                                <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                            </bs4.Col>
                                        </td>
                                    </tr>
                                    {this.state.previewbom}
                                </tbody>
                            </bs4.Table>
                        </div>
                        : this.state.type === 'ItemG2'
                            ? <div>
                                <bs4.Table bordered hover>
                                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                        <tr style={{ textAlign: 'center' }}>
                                            <th>ลำดับ</th>
                                            <th>code</th>
                                            <th>description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                ? <td>
                                                    <bs4.Col sm='12'>
                                                        <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                    </bs4.Col>
                                                </td>
                                                : ''
                                            }
                                            <td>
                                                <bs4.Col sm='12'>
                                                    <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                </bs4.Col>
                                            </td>
                                            <td>
                                                <bs4.Col sm='12'>
                                                    <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                </bs4.Col>
                                            </td>
                                        </tr>
                                        {this.state.previewbom}
                                    </tbody>
                                </bs4.Table>
                            </div>
                            : this.state.type === 'ItemG3'
                                ? <div>
                                    <bs4.Table bordered hover>
                                        <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                            <tr style={{ textAlign: 'center' }}>
                                                <th>ลำดับ</th>
                                                <th>type</th>
                                                <th>code</th>
                                                <th>description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                    ? <td>
                                                        <bs4.Col sm='12'>
                                                            <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                        </bs4.Col>
                                                    </td>
                                                    : ''
                                                }
                                                <td>
                                                    <bs4.Col sm='12'>
                                                        <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                    </bs4.Col>
                                                </td>
                                                <td>
                                                    <bs4.Col sm='12'>
                                                        <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                    </bs4.Col>
                                                </td>
                                            </tr>
                                            {this.state.previewbom}
                                        </tbody>
                                    </bs4.Table>
                                </div>
                                : this.state.type === 'IBrand1'
                                    ? <div>
                                        <bs4.Table bordered hover>
                                            <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th>ลำดับ</th>
                                                    <th>code</th>
                                                    <th>description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td></td>
                                                    {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                        ? <td>
                                                            <bs4.Col sm='12'>
                                                                <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                            </bs4.Col>
                                                        </td>
                                                        : ''
                                                    }
                                                    <td>
                                                        <bs4.Col sm='12'>
                                                            <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                        </bs4.Col>
                                                    </td>
                                                    <td>
                                                        <bs4.Col sm='12'>
                                                            <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                        </bs4.Col>
                                                    </td>
                                                </tr>
                                                {this.state.previewbom}
                                            </tbody>
                                        </bs4.Table>
                                    </div>
                                    : this.state.type === 'IBrand2'
                                        ? <div>
                                            <bs4.Table bordered hover>
                                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                    <tr style={{ textAlign: 'center' }}>
                                                        <th>ลำดับ</th>
                                                        <th>code</th>
                                                        <th>description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                            ? <td>
                                                                <bs4.Col sm='12'>
                                                                    <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                </bs4.Col>
                                                            </td>
                                                            : ''
                                                        }
                                                        <td>
                                                            <bs4.Col sm='12'>
                                                                <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                            </bs4.Col>
                                                        </td>
                                                        <td>
                                                            <bs4.Col sm='12'>
                                                                <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                            </bs4.Col>
                                                        </td>
                                                    </tr>
                                                    {this.state.previewbom}
                                                </tbody>
                                            </bs4.Table>
                                        </div>
                                        : this.state.type === 'Rawmat'
                                            ? <div>
                                                <bs4.Table bordered hover>
                                                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                        <tr style={{ textAlign: 'center' }}>
                                                            <th>ลำดับ</th>
                                                            <th>code</th>
                                                            <th>description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td></td>
                                                            {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                                ? <td>
                                                                    <bs4.Col sm='12'>
                                                                        <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                    </bs4.Col>
                                                                </td>
                                                                : ''
                                                            }
                                                            <td>
                                                                <bs4.Col sm='12'>
                                                                    <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                </bs4.Col>
                                                            </td>
                                                            <td>
                                                                <bs4.Col sm='12'>
                                                                    <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                </bs4.Col>
                                                            </td>
                                                        </tr>
                                                        {this.state.previewbom}
                                                    </tbody>
                                                </bs4.Table>
                                            </div>
                                            : this.state.type === 'SortProduct'
                                                ? <div>
                                                    <bs4.Table bordered hover>
                                                        <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <th>ลำดับ</th>
                                                                <th>code</th>
                                                                <th>description</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td></td>
                                                                {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                                    ? <td>
                                                                        <bs4.Col sm='12'>
                                                                            <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                        </bs4.Col>
                                                                    </td>
                                                                    : ''
                                                                }
                                                                <td>
                                                                    <bs4.Col sm='12'>
                                                                        <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                    </bs4.Col>
                                                                </td>
                                                                <td>
                                                                    <bs4.Col sm='12'>
                                                                        <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                    </bs4.Col>
                                                                </td>
                                                            </tr>
                                                            {this.state.previewbom}
                                                        </tbody>
                                                    </bs4.Table>
                                                </div>
                                                : this.state.type === 'Size'
                                                    ? <div>
                                                        <bs4.Table bordered hover>
                                                            <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                                <tr style={{ textAlign: 'center' }}>
                                                                    <th>ลำดับ</th>
                                                                    <th>code</th>
                                                                    <th>description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td></td>
                                                                    {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                                        ? <td>
                                                                            <bs4.Col sm='12'>
                                                                                <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                            </bs4.Col>
                                                                        </td>
                                                                        : ''
                                                                    }
                                                                    <td>
                                                                        <bs4.Col sm='12'>
                                                                            <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                        </bs4.Col>
                                                                    </td>
                                                                    <td>
                                                                        <bs4.Col sm='12'>
                                                                            <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                        </bs4.Col>
                                                                    </td>
                                                                </tr>
                                                                {this.state.previewbom}
                                                            </tbody>
                                                        </bs4.Table>
                                                    </div>
                                                    : this.state.type === 'Detail'
                                                        ? <div>
                                                            <bs4.Table bordered hover>
                                                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                                    <tr style={{ textAlign: 'center' }}>
                                                                        <th>ลำดับ</th>
                                                                        <th>code</th>
                                                                        <th>description</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td></td>
                                                                        {this.state.type === 'ItemG1' || this.state.type === 'ItemG3'
                                                                            ? <td>
                                                                                <bs4.Col sm='12'>
                                                                                    <bs4.Input type="text" name="type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                                </bs4.Col>
                                                                            </td>
                                                                            : ''
                                                                        }
                                                                        <td>
                                                                            <bs4.Col sm='12'>
                                                                                <bs4.Input type="text" name="code" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                            </bs4.Col>
                                                                        </td>
                                                                        <td>
                                                                            <bs4.Col sm='12'>
                                                                                <bs4.Input type="text" name="description" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                                                            </bs4.Col>
                                                                        </td>
                                                                    </tr>
                                                                    {this.state.previewbom}
                                                                </tbody>
                                                            </bs4.Table>
                                                        </div>
                                                        : <div></div>
                }
            </div>
        </div>
    }
}

export default Flim_EditMasterOption